/**
 * #270 — the send-critical set ("Tier 1"): pending and in-flight rows due within the send horizon.
 *
 * The Chrome extension / Chrome-gateway send loop reads ONLY redux, so these rows must be loaded
 * completely and must never be evicted. Kept free of store imports so the reducer layer can use
 * the predicate without a cycle.
 */
import { PLANNER_LOAD_PLAN } from '@common/services/planner-filters';

/** How far ahead of now the send-critical set reaches (spec D7: op-approved 7 days). */
export const SEND_HORIZON_MS = 7 * 24 * 60 * 60 * 1000;

/** Every status that can be due to send: the "eagerUnbounded" plan minus the terminal `failed`. */
export const TIER1_STATUSES: readonly string[] = PLANNER_LOAD_PLAN.eagerUnbounded.filter((s) => s !== 'failed');

interface SendCriticalCandidate {
    status?: string;
    dueDate?: Date | string | number | null;
    deleted?: boolean;
}

/** True for a row the redux-only send loop may need: Tier-1 status, due no later than now+horizon. */
export const isSendCriticalUserMessage = (row: SendCriticalCandidate, now: number = Date.now()): boolean => {
    if (row.deleted === true) return false; // a soft-deleted row is never sent; let it be evicted
    if (!row.status || !TIER1_STATUSES.includes(row.status)) return false;
    if (row.dueDate == null) return true; // no due time: keep it, never risk dropping a sendable row
    const due = new Date(row.dueDate).getTime();
    return Number.isNaN(due) || due <= now + SEND_HORIZON_MS;
};
